import Vue from "vue";

// When the request succeeds
const success = (data, context) => {
  context.booking = data.booking;
  context.guest = data.guest[0];
  context.rental = data.rental[0];
  context.invoices = data.payments;

  context.invoices.map((payment) => {
    payment.vat = payment.vat || context.rental.vat;
    if (payment.type === "service charge" || payment.type === "taxes") {
      payment.vat = 0;
    }

    if (payment.invoice_payment) {
      const invoicePayment = payment.invoice_payment;
      payment.description = invoicePayment.description || payment.description;
      payment.amount = invoicePayment.gross
        ? parseFloat(invoicePayment.gross)
        : payment.amount;
      payment.vat = invoicePayment.tax
        ? parseFloat(invoicePayment.tax)
        : payment.vat;
    }
  });

  if (context.booking.status === 1 && context.booking.payment_is_done === 1) {
    if (context.lang === "fr")
      document.getElementById("invoiceOutline").style.backgroundImage =
        "url('static/assets/images/paid_mark_fr.jpg')";
    else
      document.getElementById("invoiceOutline").style.backgroundImage =
        "url('static/assets/images/paid_mark_en.jpg')";
  }
  context.invoice = data.invoice;
  context.calculate_invoice_sum();
};

// When the request fails
const failed = (context, error) => {
  context.showToasterError(error);
  Vue.router.push({
    name: "bookings.index",
  });
};

export default (context, permalink) =>
  Vue.$http
    .get(`/get-invoice/${permalink}`, {})
    .then((response) => {
      if (response.status === 200) {
        success(response.data, context);
      }
    })
    .catch((error) => {
      failed(context, error);
    });



// WEBPACK FOOTER //
// ./src/app/services/invoice/getInvoice.js